/** @format */

import axios from "axios";
import { Input, Modal } from "antd";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState, useRef } from "react";

import pdf from "../../../../../icons/pdf.png";
import excel from "../../../../../icons/excel.png";
import print from "../../../../../icons/print.png";
import LineChartComponent from "../components/lineChart";
import { header } from "../../../../../components/api/Header";
import { monthName } from "../../../../../components/functions/Month";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { ExcelPrint, Pdf } from "../../../../../components/functions/Print";
import { getEnv } from "../../../../../lib/env";

const buttonList = [
  { mode: "first", label: "I dekada" },
  { mode: "second", label: "II dekada" },
  { mode: "third", label: "III dekada" },
  { mode: "all", label: "Batafsil" },
];

function Page3({ month }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isSelectData, setIsSelectData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [searchText, setSearchText] = useState("");

  const getInitialViewMode = () => {
    const day = new Date().getDate();
    if (day >= 1 && day <= 10) return "first";
    if (day >= 11 && day <= 20) return "second";
    return "third";
  };

  const [viewMode, setViewMode] = useState(getInitialViewMode());

  const filteredData = data?.filter((item) =>
    item.nomi?.toLowerCase().includes(searchText.toLowerCase())
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoadingData(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/republik/amudaryo/table?month=" +
            month,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.error("Xato yuz berdi:", e);
        alert("Serverga ulanishda xatolik yuz berdi.");
      } finally {
        setLoadingData(false);
      }
    };

    fetchData();
  }, [month]);

  useEffect(() => {
    if (loadingData) return;

    const todayCol = document.getElementById("istoday-balans");

    if (todayCol) {
      todayCol.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [loadingData, viewMode]);

  const daysInMonth = new Date(
    new Date(month).getFullYear(),
    new Date(month).getMonth() + 1,
    0
  ).getDate();

  const getChunkRange = (mode) => {
    switch (mode) {
      case "first":
        return { start: 1, end: 10 };
      case "second":
        return { start: 11, end: 20 };
      case "third":
        return { start: 21, end: daysInMonth };
      case "all":
        return { start: 1, end: daysInMonth };
      default:
        return { start: 1, end: 10 };
    }
  };

  const { start, end } = getChunkRange(viewMode);
  const range = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  if (loadingData) <LoadingCard loading={loadingData} heightSize='80vh' />;

  return (
    <div className='table-box-con'>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Qidiruv'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "0.75rem",
          }}>
          <ul className='tabs-component'>
            {buttonList.map((btn, index) => (
              <li key={`${btn.mode}-${index}`}>
                <button
                  className={viewMode === btn.mode ? "active" : ""}
                  onClick={() => setViewMode(btn.mode)}>
                  {btn.label}
                </button>
              </li>
            ))}
          </ul>

          <ul className='table-top-right'>
            <li>
              <button className='btn p-0' onClick={() => generatePDF()}>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button onClick={() => Pdf("tblData")} className='btn p-0'>
                <img src={pdf} alt='404' />
              </button>
            </li>

            <li>
              <button
                className='btn p-0'
                onClick={() =>
                  ExcelPrint("Amudaryo balansi", month, "tblData")
                }>
                <img src={excel} alt='404' />
              </button>
            </li>
          </ul>
        </div>
      </div>

      {loadingData ? (
        <LoadingCard loading={loadingData} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead' id='tableFlexible'>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <table
              id='tblData'
              className='table table-bordered table-style table_fonts_change'>
              <thead>
                <tr>
                  <th className='sticky' style={{ left: "0" }} rowSpan={2}>
                    №
                  </th>

                  <th
                    style={{
                      left: "36px",
                    }}
                    className='sticky'
                    rowSpan={2}>
                    Suv olish nuqtalari
                  </th>

                  <th className='sticky' style={{ left: "215px" }} rowSpan={2}>
                    Birligi
                  </th>

                  <th
                    className='sticky'
                    style={{
                      left: "290px",
                    }}
                    rowSpan={2}>
                    Yillar
                  </th>

                  <th colSpan={range.length}>{monthName(month)}</th>

                  <th
                    style={{
                      width: "100px",
                      maxWidth: "100px",
                      minWidth: "100px",
                    }}
                    rowSpan={2}>
                    O'rtacha
                  </th>

                  <th
                    style={{
                      width: "110px",
                      maxWidth: "110px",
                      minWidth: "110px",
                    }}
                    rowSpan={2}>
                    Hajm (mln m3)
                  </th>

                  <th
                    style={{
                      width: "110px",
                      maxWidth: "110px",
                      minWidth: "110px",
                    }}
                    rowSpan={2}>
                    Eng past qiymat
                  </th>

                  <th
                    style={{
                      width: "110px",
                      maxWidth: "110px",
                      minWidth: "110px",
                    }}
                    rowSpan={2}>
                    Eng yuqori qiymat
                  </th>
                </tr>

                <tr>
                  {range.map((day, index) => (
                    <th key={`table1-${day + index}`}>{day}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filteredData?.map((d, i) => (
                  <React.Fragment key={i}>
                    <tr
                      onClick={() => {
                        setIsOpen(true);
                        setIsSelectData(d);
                      }}
                      key={`${i}-prev`}
                      className='font_size_fix'>
                      <td
                        className='sticky'
                        rowSpan={2}
                        style={{
                          alignContent: "center",
                          left: "0",
                          width: "36px",
                          maxWidth: "36px",
                          minWidth: "36px",
                        }}>
                        {i + 1}
                      </td>

                      <td
                        rowSpan={2}
                        className='sticky'
                        style={{
                          textAlign: "left",
                          alignContent: "center",
                          width: "290px",
                          // maxWidth: "290px",
                          // minWidth: "290px",
                          left: "37px",
                        }}>
                        {d.nomi}
                      </td>

                      <td
                        className='sticky'
                        style={{
                          alignContent: "center",
                          left: "215px",
                          width: "80px",
                          maxWidth: "80px",
                          minWidth: "80px",
                        }}
                        rowSpan={2}>
                        {d.birligi}
                      </td>

                      <td
                        className='sticky'
                        style={{
                          left: "290px",
                          width: "80px",
                          maxWidth: "80px",
                          minWidth: "80px",
                        }}>
                        {new Date(month).getFullYear() - 1}
                      </td>

                      {range.map((day) => (
                        <td
                          key={`${day + i}-prev`}
                          style={{
                            color:
                              d["kun" + day]?.[1] === null ? "red" : "#25213b",
                          }}>
                          {d["kun" + day]?.[1] === null
                            ? "-"
                            : d["kun" + day]?.[1]}
                        </td>
                      ))}

                      <td style={{ width: "100px" }}>
                        {ortacha_oqim_tezligi(d.birligi, d, range, 1)}
                      </td>

                      <td style={{ width: "100px" }}>
                        {ortacha_hajm(d.birligi, d, range, 1)}
                      </td>

                      <td style={{ width: "100px" }}>{min_value(d, range)}</td>

                      <td style={{ width: "100px" }}>{max_value(d, range)}</td>
                    </tr>

                    <tr
                      onClick={() => {
                        setIsOpen(true);
                        setIsSelectData(d);
                      }}
                      key={`${i}-curr`}>
                      <td className='sticky' style={{ left: "290px" }}>
                        {new Date(month).getFullYear()}
                      </td>

                      {range.map((day) => {
                        const today = new Date().getDate();
                        const istoday =
                          today === day && viewMode === "all" ? day : null;

                        return (
                          <td
                            key={`${day + i}-curr`}
                            id={day === istoday ? "istoday-balans" : undefined}
                            style={{
                              width: "60px",
                              maxWidth: "60px",
                              minWidth: "60px",
                              color:
                                d["kun" + day]?.[0] === null
                                  ? "red"
                                  : "#25213b",
                            }}>
                            {d["kun" + day]?.[0] === null
                              ? "-"
                              : Number(d["kun" + day]?.[0]) % 1 === 0
                              ? d["kun" + day]?.[0]
                              : Number(d["kun" + day]?.[0]).toFixed(1)}
                          </td>
                        );
                      })}

                      <td style={{ width: "100px" }}>
                        {ortacha_oqim_tezligi(d.birligi, d, range, 0)}
                      </td>

                      <td style={{ width: "100px" }}>
                        {ortacha_hajm(d.birligi, d, range, 0)}
                      </td>

                      <td style={{ width: "100px" }}>{min_value(d, range)}</td>

                      <td style={{ width: "100px" }}>{max_value(d, range)}</td>
                    </tr>
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        centered
        style={{
          minWidth: "1200px",
        }}
        title={isSelectData.nomi}>
        <LineChartComponent month={month} monthlyData={isSelectData} />
      </Modal>
    </div>
  );
}

export default Page3;

const ortacha_oqim_tezligi = (birligi, qiymat, range, valueIndex) => {
  if (birligi === "mln m3") return "";

  const values = range
    .map((day) => Number(qiymat["kun" + day]?.[valueIndex]))
    .filter((v) => !isNaN(v));

  if (values.length === 0) return "";

  const sum = values.reduce((acc, v) => acc + v, 0);
  return (sum / range.length).toFixed(1);
};

const ortacha_hajm = (birligi, qiymat, range, valueIndex) => {
  if (birligi === "mln m3") {
    const values = range
      .map((day) => Number(qiymat["kun" + day]?.[valueIndex]))
      .filter((v) => !isNaN(v));

    return values[range.length];
  }

  if (birligi !== "m3/sek") return "";

  const values = range
    .map((day) => Number(qiymat["kun" + day]?.[valueIndex]))
    .filter((v) => !isNaN(v));

  const sum = values.reduce((acc, v) => acc + v, 0);
  return ((sum * 24 * 3600) / 1000000 / range.length).toFixed(1);
};

const min_value = (qiymat, range) => {
  const values = range.map((day) => Number(qiymat["kun" + day]?.[0]));
  return Math.min(...values).toFixed(1);
};

const max_value = (qiymat, range) => {
  const values = range.map((day) => Number(qiymat["kun" + day]?.[0]));
  return Math.max(...values).toFixed(1);
};
